import LoginView from "./login-view";
import {events}  from "../../commun/backbone/decorators";


@events({
            'click #sso-openidconnect' : '_onClickSSOOpenIdConnect',
            'input #login-username' : '_onInputUsername',
        })
class LoginPageView extends LoginView
{

    initialize(options)
    {
        super.initialize(options);

        //on met en place un listener pour ajuster la hauteur du document, on n'utilise pas this._addEventListener car n'existe pas sur la page de login
        window.addEventListener('resize', this._setDocumentHeight);
        this._setDocumentHeight();
    }

    remove() {
        window.removeEventListener('resize', this._setDocumentHeight);
        return super.remove();
    }

    _setDocumentHeight()
    {
        const doc = document.documentElement
        doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
    }

    render()
    {
        this.$ssoopenidconnect = $('#sso-openidconnect');
        this.$btnconfigure = $('#btn-configure');
        return super.render();
    }


    _onInputUsername(event)
    {
        if (!this.model.get('with_configuration')){
            return ;
        }
        const that = this;
        clearTimeout(this.timeoutid);
        this.timeoutid = setTimeout(function (){
            that.$username.addClass('is-loading');
            that.model.fGetUserInfo(that.$username.val())
                .then(function (data)
                      {
                          if (data.with_configuration)
                          {
                              that.$btnconnexion.removeClass('without-config');
                              that.$btnconfigure.removeClass('d-none');
                          }
                          else {
                              that.$btnconnexion.addClass('without-config');
                              that.$btnconfigure.addClass('d-none');
                          }

                          //gestion de la locale
                          that.model.loadUserLanguage(data.language_code);
                      })
                .catch(function(jqx){
                    that.$btnconnexion.addClass('without-config');
                    that.$btnconfigure.addClass('d-none');
                })
                .finally(function (){
                    that.$username.removeClass('is-loading');
                });
        }, 400);
    }

    ssoConnect()
    {
        let params = {
            'm_sLocale': this.$locale.val(),
        };

        if (this.$timezone.length){
            params['m_sTimeZone']=this.$timezone.val();
        }

        const paramsEncoded = $.param( params );
        window.location = this.$ssoopenidconnect.attr('data-url')+'?' + paramsEncoded;

    }

    _onClickSSOOpenIdConnect(event)
    {
        event.preventDefault();
        this.ssoConnect();
    }
}
export default LoginPageView;